import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    // Initialize end time in local storage if not present
    const storedEndTime = localStorage.getItem('nailsExpertTimerEnd');
    let endTime: number;
    if (storedEndTime && new Date(storedEndTime).getTime() > Date.now()) {
      endTime = new Date(storedEndTime).getTime();
    } else {
      // Set to 30 minutes from now
      const now = new Date();
      now.setMinutes(now.getMinutes() + 30);
      endTime = now.getTime();
      localStorage.setItem('nailsExpertTimerEnd', now.toISOString());
    }
    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = endTime - now;
      if (distance < 0) {
        // Reset timer if expired (for demo purposes, or keep at 0)
        // For sales page, usually we want it to stay at 0 or reset. Let's stay at 0.
        clearInterval(timer);
        setTimeLeft({
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0
        });
      } else {
        setTimeLeft({
          days: Math.floor(distance / (1000 * 60 * 60 * 24)),
          hours: Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
          minutes: Math.floor(distance % (1000 * 60 * 60) / (1000 * 60)),
          seconds: Math.floor(distance % (1000 * 60) / 1000)
        });
      }
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const TimeUnit = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center mx-1 md:mx-2" data-id="element-193">
      <div className="bg-white border border-[#C9A96E] text-[#9B2C5E] font-playfair font-bold text-2xl md:text-4xl w-12 h-12 md:w-16 md:h-16 flex items-center justify-center rounded-lg shadow-sm" data-id="element-194">
        {value.toString().padStart(2, '0')}
      </div>
      <span className="text-[10px] md:text-xs uppercase tracking-wider mt-1 text-[#1A1A2E] font-medium" data-id="element-195">
        {label}
      </span>
    </div>;
  return <div className="flex justify-center items-center py-4" data-id="element-196">
      <TimeUnit value={timeLeft.minutes} label="Min" data-id="element-197" />
      <span className="text-[#C9A96E] font-bold text-xl md:text-2xl -mt-4" data-id="element-198">
        :
      </span>
      <TimeUnit value={timeLeft.seconds} label="Seg" data-id="element-199" />
    </div>;
}